import {call, put, takeEvery, fork} from 'redux-saga/effects';
import * as actions from '../actions/datoscliente';
import datosCliente from '../services/datosCliente';

function* getClientData({clienteId}) {
    yield put(actions.startLoading());
    try {
        const res = yield call(datosCliente.getClientData, clienteId);
        if(res){
            yield put(actions.responseClienteDataSucceeded(res));
        }
    } catch (error) {
        yield put(actions.responseError(error));
    }
}

function* getContactoPorTipoEmail({clienteId, tipoEmailId}) {
    yield put(actions.startLoading());
    try {
        const res = yield call(datosCliente.getContactoPorTipoEmail, clienteId, tipoEmailId);
        if(res){
            yield put(actions.responseContactoEmailSucceeded(res));
        }
    } catch (error) {
        yield put(actions.responseError(error));
    }
}

function* getTiendaByCliente({clienteId}) {
    yield put(actions.startLoading());
    try {
        const res = yield call(datosCliente.getTiendaByCliente, clienteId);
        if(res){
            yield put(actions.responseTiendasSucceeded(res));
        }
    } catch (error) {
        yield put(actions.responseError(error));
    }
}

function* createContacto({contactoRequest}) {
    yield put(actions.startLoading());
    try {
        const contactoResponse = yield call(datosCliente.createContacto, contactoRequest);
        if(contactoResponse){
            yield put(actions.responseContactoSucceeded(contactoResponse));
        } 
    } catch (error) {
        yield put(actions.responseError(error.response.data.message));
    }
}

function* updateContacto({contactoRequest}) {
    yield put(actions.startLoading());
    try {
        const contactoResponse = yield call(datosCliente.updateContacto, contactoRequest);
        if(contactoResponse){
            yield put(actions.responseContactoSucceeded(contactoResponse));
        } 
    } catch (error) {
        yield put(actions.responseError(error.response.data.message));
    }
}

function* deleteContacto({contactoRequest}) {
    yield put(actions.startLoading());
    try {
        const contactoResponse = yield call(datosCliente.deleteContacto, contactoRequest);
        if(contactoResponse){
            yield put(actions.responseContactoSucceeded(contactoResponse));
        } 
    } catch (error) {
        yield put(actions.responseError(error.response.data.message));
    }
}

function* watchGetDatosCliente() {
    yield takeEvery(actions.Types.GET_DATOS_CLIENTE, getClientData);
}
function* watchGetContactoPorTipoEmail() {
    yield takeEvery(actions.Types.GET_CONTACTO_EMAIL_REQUEST, getContactoPorTipoEmail);
}
function* watchGetTiendaByCliente() {
    yield takeEvery(actions.Types.GET_TIENDA_REQUEST, getTiendaByCliente);
}
function* watchCreateContacto() {
    yield takeEvery(actions.Types.CREATE_CONTACTO_REQUEST, createContacto);
}
function* watchUpdateContacto() {
    yield takeEvery(actions.Types.UPDATE_CONTACTO_REQUEST, updateContacto);
}
function* watchDeleteContacto() {
    yield takeEvery(actions.Types.DELETE_CONTACTO_REQUEST, deleteContacto);
}

const datosclienteSagas = [
    fork(watchGetDatosCliente),    
    fork(watchGetContactoPorTipoEmail),    
    fork(watchGetTiendaByCliente),    
    fork(watchCreateContacto),    
    fork(watchUpdateContacto),    
    fork(watchDeleteContacto)
]

export default datosclienteSagas;